<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M14.5 4.20898V11.792L8 15.584L1.5 11.792V4.20898L8 0.416992L14.5 4.20898ZM3 10.9297L7.25 13.4082V8.39844L3 5.9707V10.9297ZM8.75 8.39844V13.4082L13 10.9297V5.9707L8.75 8.39844ZM3.71484 4.65137L8 7.09961L12.2832 4.65234L7.99902 2.15332L3.71484 4.65137Z"
    fill="currentColor"
  />
</svg>
